import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/components/AuthProvider";
import { PrePackCartonOperatorStack } from "@/pages/prepack/PrePackCartonOperatorStack";

import {
  activeStationOperatorsQueryKey,
  fetchActiveStationOperators,
  LABOR_STATION_PRESENCE_INTERVAL_MS,
  type ActiveStationOperatorPage,
  type ReceivingPresenceFloor,
} from "@/lib/labor/laborOperatorPresence";

export function LaborStationOperatorPresence(props: {
  stationPage: ActiveStationOperatorPage;
  receivingFloor?: ReceivingPresenceFloor;
  className?: string;
}): JSX.Element | null {
  const { stationPage, receivingFloor, className } = props;
  const { session } = useAuth();
  const viewerUserId = session?.user?.id ?? null;
  const viewerKnown = viewerUserId !== null && viewerUserId !== "";

  const operatorsQuery = useQuery({
    queryKey: activeStationOperatorsQueryKey(stationPage, receivingFloor),
    queryFn: () => fetchActiveStationOperators(stationPage, receivingFloor),
    staleTime: 10_000,
    refetchInterval: LABOR_STATION_PRESENCE_INTERVAL_MS,
  });

  const operators = operatorsQuery.data ?? [];
  const showStack =
    operators.length > 0 && (!viewerKnown || operators.some((operator) => operator.userId !== viewerUserId));
  if (!showStack) {
    return null;
  }

  return (
    <div className={className}>
      <div className="flex flex-col items-end gap-0.5">
        <span className="text-[10px] font-medium uppercase tracking-wide text-slate-500">
          {viewerKnown ? "Other operators at this station" : "Operators at this station"}
        </span>
        <PrePackCartonOperatorStack
          operators={operators}
          viewerUserId={viewerUserId}
          omitViewer={viewerKnown}
        />
      </div>
    </div>
  );
}
